/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowplacelater3Inputs */

const en_aiflowplacelater3 = /** @type {(inputs: Aiflowplacelater3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venue to follow`)
};

const de_aiflowplacelater3 = /** @type {(inputs: Aiflowplacelater3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ort folgt`)
};

/**
* | output |
* | --- |
* | "Venue to follow" |
*
* @param {Aiflowplacelater3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowplacelater3 = /** @type {((inputs?: Aiflowplacelater3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowplacelater3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowplacelater3(inputs)
	return de_aiflowplacelater3(inputs)
});
export { aiflowplacelater3 as "aiFlowPlaceLater" }